import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Oficio } from 'src/app/models/BPM/oficio';
// import { EvaluacionPreliminarService } from 'src/app/services/bpm/evaluacion-preliminar.service';
import { MatDialog } from '@angular/material';
import { openModalMensaje } from 'src/app/general/variables';
import { NgxSpinnerService } from 'ngx-spinner';
import { General } from 'src/app/models/General';

@Component({
  selector: 'app-doc-a-generar',
  templateUrl: './doc-a-generar.component.html',
  styleUrls: ['./doc-a-generar.component.css']
})
export class DocAGenerarComponent implements OnInit {

  flgOficio = false;
  flgMemo = false;
  flgCarta = false;

  oficio: Oficio = new Oficio();
  general: General = new General();

  @Output() generarDocOut = new EventEmitter();

  constructor(  public dialog: MatDialog, private spinner: NgxSpinnerService) { }

  ngOnInit() {
  }

  _checkOficio(event: any) {

    this.flgOficio = event.target.checked;

  }

  _checkMemo(event: any) {

    this.flgMemo = event.target.checked;

  }

  _checkCarta(event: any) {

    this.flgCarta = event.target.checked;

  }

  _GenerarDocumento() {
    // PENDIENTE LO DE GENERACIÓN DE OFICIOS
    // Generación de ofiios
    // this._generarOficio();

    this.general.flgCampo1 = this.flgOficio;
    this.general.flgCampo2 = this.flgMemo;
    this.general.flgCampo3 = this.flgCarta;


    this.generarDocOut.emit(this.general);
  }

  _GuardarDocumento() {
    // PENDIENTE LO DE GENERACIÓN DE OFICIOS
  }

}
